import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PrivateOutlet, PrivateOutletNotLogin, PrivateOutletPermission } from './components/privateOutlet';
import Login from './features/account/page/login';
import { logout } from './features/account/redux/action';
import DashboardStorage from './features/dashboardStorage/page';
import ManagerStorage from './features/manageStorage/page';
import ManagerUser from './features/manageUser/page';
import { setHeaders } from './utils/callApi';
import ToastTopHelper from './utils/toast';

const AppRouter = () => {
  const dispatch = useDispatch();
  const [isLoggedIn, account] = useSelector((state) => [state.account.isLoggedIn, state.account.account]);
  
  useEffect(() => {
    if(isLoggedIn && account && account.token) {
      setHeaders({
        "Content-Type": "application/json",
        "Authorization": "Bearer " + account.token,
      })
    } else {
      setHeaders({
        "Content-Type": "application/json",
      })
    }
  },[isLoggedIn, account]);

  useEffect(() => {
    if(account.user && account.user.exp && Number(account.user.exp) * 1000 < Date.now()){
      dispatch(logout());
      ToastTopHelper.error("Phiên hoạt động đã hết hạn. Vui lòng đăng nhập lại.")
    }
  })
  
  return (
    <>
      <Router>
        <Routes>
          <Route element={<PrivateOutletNotLogin />}>
            <Route path="/login" exact element={<Login></Login>} />
          </Route>
          <Route element={<PrivateOutlet></PrivateOutlet>}>
            <Route element={<PrivateOutletPermission link="/"></PrivateOutletPermission>}>
              <Route path="/" exact element={<DashboardStorage></DashboardStorage>} />
            </Route>
            <Route element={<PrivateOutletPermission link="/manage_user"></PrivateOutletPermission>}>
              <Route path="/manage_user" exact element={<ManagerUser></ManagerUser>}/>
            </Route>
            <Route element={<PrivateOutletPermission link="/manage_storage"></PrivateOutletPermission>}>
              <Route path="/manage_storage" exact element={<ManagerStorage></ManagerStorage>}/>
            </Route>
          </Route>
          <Route path="*" exact element={<Navigate to='/'></Navigate>}/>
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default AppRouter;
